import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { UserService } from "../../api/services/userService";

const initialState = {
  userInfo: null,
  userSubscription: null,
  isLoading: false,
  isSubscriptionLoading: false
};

export const getUserInfoThunk = createAsyncThunk("user/get", async (args) => {
  const { checkForEmail = false, navigate = null } = args || {};
  try {
    const res = await UserService.userInfo();
    if (checkForEmail && !res.data.email) {
      navigate?.("/");
      return;
      
    }
    return res.data;
  } catch (e) {
    console.log(e);
    if (checkForEmail) {
      navigate("/");
    }
  }
});

export const getUserSubscriptionThunk = createAsyncThunk(
  "user/getSubscription",
  async () => {
    try {
      const response = await UserService.userSubscription();
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
);

const userSlice = createSlice({
  name: "userSlice",
  initialState,
  reducers: {
    reset() {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserInfoThunk.fulfilled, (state, { payload }) => {
        if (payload) {
          state.userInfo = payload;
        }
        state.isLoading = false;
      })
      .addCase(getUserInfoThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUserSubscriptionThunk.pending, (state) => {
        state.isSubscriptionLoading = true;
      })
      .addCase(getUserSubscriptionThunk.fulfilled, (state, { payload }) => {
        state.userSubscription = payload;
        state.isSubscriptionLoading = false;
      })
      .addCase(getUserSubscriptionThunk.rejected, (state) => {
        state.isSubscriptionLoading = false;
      });
  }
});

export const reducer = userSlice.reducer;
